import { useState, useEffect } from "react";
import {
  postDoctors,
  handleSoaRequest,
  recommendContentDiag,
  pageDoctorInfo,
} from "api/doctor-list";
import { useParams } from "react-router-dom";

// import { useMount } from "hooks/use-lifecycle";
import jdh from "../../asset/img/login/jdh.png";
import ask1 from "../../asset/img/login/ask1.png";
import ask2 from "../../asset/img/login/ask2.png";
import img3 from "../../asset/img/login/img3.png";
import logo from "../../asset/img/login/logo.png";
import Prescribible from "../../asset/img/login/Prescribible.png";
import selfSupport from "../../asset/img/login/self-support.png";
import Triple from "../../asset/img/login/Triple-A.png";
import TripleHospital from "../../asset/img/login/Class-A-tertiary-hospital.png";
import icon_right from "../../asset/img/login/icon_right.png";

import QRCode from "qrcode.react";
import { Popover } from "antd";
import styles from "./index.less";
import { ErrorComp } from "components/error";
import { getQrCodeUrl } from "utils/doctor";
import { queryRecommendArticles, recommendContentQaGW } from "api/hospital";

const Pccontent = () => {
  const params = useParams<Record<any, any>>();
  const [departData, setDepartData] = useState<any>();
  const [departDatas, setDepartDatas] = useState<any>();
  const [askDatas, setAskDatas] = useState<any>();
  const [contentArticle, setContentArticle] = useState<any>();
  const [contentDiagData, setContentDiagData] = useState<any>();
  const [contentOtherArt, setContentOtherArt] = useState<any>();
  const [dataInfo, setDataInfo] = useState<any>();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (params.id) {
      // 文章内容
      handleSoaRequest({
        osName: "content",
        tenantId: 287,
        version: 11,
        methodName: "queryContentByIdMapParam21",
        floorId: 4180,
        contentId: parseInt(params.id),
        appId: "c59cb704c24245a58768efa1ca1b4940",
      }).then((res: any) => {
        if (res.contentId) {
          setContentArticle(res);
        }
      }).finally(() => setLoading(false));
      // 医生回答
      handleSoaRequest({
        osName: "content",
        tenantId: 287,
        version: 11,
        methodName: "queryContentsByMapParam30",
        floorId: 4182,
        contentTypes: [15],
        contentRelations: [
          { contentRelationId: parseInt(params.id), relationType: 1 },
        ],
        contentStatus: [1],
        withAuthorDetail: true,
        withContent: true,
        pageNo: 1,
        pageSize: 20,
        appId: "c59cb704c24245a58768efa1ca1b4940",
      }).then((res: any) => {
        setDataInfo(res?.data);
        let arr: any = [];
        res?.data &&
          res?.data.length > 0 &&
          res?.data.map((val: any) => {
            val.authors &&
              val.authors.map((itme: any) => {
                if (itme.authorType == 2 && itme.doctorInfo.docId) {
                  arr.push(itme.doctorInfo.docId);
                }
              });
          });

        arr.length > 0 &&
          pageDoctorInfo({ doctorIds: arr }).then((doctorRes: any) => {
            setDepartData(doctorRes.data[0]);
            setDepartDatas(doctorRes.data);
          });
      });
      // 问答推荐
      handleSoaRequest({
        osName: "content",
        tenantId: 287,
        version: 13,
        methodName: "recommendContentAsk431",
        floorId: 5092,
        pageSize: 10,
        contentId: parseInt(params.id),
        contentBusinessIds: [375, 359, 387],
        appId: "c59cb704c24245a58768efa1ca1b4940",
      }).then((res: any) => {
        setAskDatas(res);
      });
      // 医患交流推荐
      // recommendContentDiag({
      //   osName: "content",
      //   tenantId: 287,
      //   version: 13,
      //   methodName: "recommendContentQa435",
      //   floorId: 5092,
      //   appId: "c59cb704c24245a58768efa1ca1b4940",
      //   contentId: parseInt(params.id),
      //   pageSize: 10,
      // })
      recommendContentQaGW({
        tenantId: 287,
        version: 13,
        contentId: parseInt(params.id),
        pageSize: 10,
      })
      .then((res: any) => {
        setContentDiagData(res);
      });
      // 其他文章
      // handleSoaRequest({
      //   osName: "content",
      //   tenantId: 287,
      //   version: 13,
      //   methodName: "recommendContentArticle428",
      //   floorId: 5092,
      //   contentId: parseInt(params.id),
      //   contentBusinessIds: [375, 359, 387],
      //   appId: "c59cb704c24245a58768efa1ca1b4940",
      //   pageSize: 10,
      // })
      queryRecommendArticles({
        tenantId: 287,
        contentId: parseInt(params.id),
        contentBusinessIds: [375, 359, 387],
        pageSize: 10,
      })
      .then((res: any) => {
        setContentOtherArt(res);
      });
    }
  }, []);

  const onClickOpen = (url?: any) => {
    if (url) {
      window.open(url);
    } else {
      if (window.location.origin.indexOf("cont.jd") != -1) {
        window.open("https://cont.jd.com");
      } else {
        window.open("/");
      }
    }
  };

  const deleteTag = (html: string) =>
    html
      .replace(/<.+?>/g, "")
      .replace(/<\/.+>/g, "")
      .replace(/\s+/g, " ")
      .replace(/<img.+\/>/gi, "")
      .replace(/\%/g, "")
      .trim();
  const timeStampFun = (timeStamp: string | number | Date) => {
    const date = new Date(timeStamp);
    const year = date.getFullYear();
    let month: any = Number(date.getMonth()) + 1;
    const day = date.getDate();
    let hour: any = date.getHours();
    if (month < 10) {
      month = "0" + month;
    }
    if (hour < 10) {
      hour = "0" + hour;
    }
    let minute: any = date.getMinutes();
    if (minute < 10) {
      minute = "0" + minute;
    }
    return year + "." + month + "." + day;
  };
  const contentParagraphs1 =
    contentArticle?.contentParagraphs &&
    contentArticle?.contentParagraphs.length > 0 &&
    deleteTag(contentArticle?.contentParagraphs[0].paragraphContent);
  if (contentParagraphs1 && contentParagraphs1.length > 100) {
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute("content", contentParagraphs1);
  } else {
    let dataInfoDescription =
      dataInfo &&
      dataInfo.length > 0 &&
      dataInfo[0].contentParagraphs &&
      dataInfo[0].contentParagraphs.length > 0 &&
      deleteTag(dataInfo[0].contentParagraphs[0].paragraphContent);
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute("content", contentParagraphs1 + dataInfoDescription);
  }
  document.title =
    contentArticle && contentArticle?.contentName + " - 京东健康";

  document
    .querySelector('meta[name="keywords"]')
    ?.setAttribute("content", contentArticle && contentArticle?.contentName);
  const qrCodeUrl = getQrCodeUrl(departData?.docId);
  const QRCodeFun = () => {
    if (dataInfo && dataInfo.length == 1 && departData) {
      return (
        <QRCode
          id="qrCode"
          value={qrCodeUrl}
          size={80}
        />
      );
    } else {
      return (
        <QRCode
          id="qrCode"
          value={"https://cont.jd.com/mask/" + params.id}
          size={80}
        />
      );
    }
  };
  const content = () => {
    return (
      <div className={styles.overbookingCodebotton}>
        {QRCodeFun()}
        <div>
          {dataInfo && dataInfo.length == 1 && departData ? (
            <>
              <h3>扫码关注医生</h3>
              <h6>关注{departData?.docName}医生，方便随时提问</h6>
            </>
          ) : (
            <>
              <h3>立即提问</h3>
              <h6>手机扫一扫，快速提问</h6>
            </>
          )}
        </div>
      </div>
    );
  };
  return (
    <div className={styles.pccontent}>
      {!loading && !contentArticle && <ErrorComp />}
      {/* 描述信息 */}
      { !loading && contentArticle &&
        <div className={styles.describe}>
          <p>
            当前位置：
            <i
              data-a-href="/"
              data-a-nofollow="true"
              onClick={() => {
                setTimeout(() => {
                  onClickOpen();
                }, 200);
              }}
            >
              首页
            </i>
            <span>{">"}</span>
            {departData?.hospitalName &&
            departData?.docName &&
            dataInfo &&
            dataInfo.length === 1 ? (
              <>
                {departData?.hospitalName}
                {departData?.hospitalName && <span>{">"}</span>}
                <span
                  onClick={() => {
                    onClickOpen(
                      window.location.origin + "/doctor/" + departData?.docId
                    );
                  }}
                  data-tag-h1
                >
                  {departData?.docName}
                </span>
                <span>{">"}</span>
              </>
            ) : null}
          </p>
          {contentArticle && (
            <h1 className={styles.describe1} data-tag-h1>
              {contentArticle.contentName}
            </h1>
          )}
        </div>
      }
      {/* 内容 */}
      { !loading && contentArticle &&
        <div className={styles.content}>
          {/* 左 */}
          <div className={styles.left}>
            {/* 问答 */}
            {contentArticle && (
              <div className={styles.askBox}>
                {/* 患者问题 */}
                <div className={styles.problem}>
                  <img src={ask1} alt="" />
                  <p>{contentArticle?.contentName}</p>
                </div>
                <div className={styles.askDescribe}>
                  症状描述：
                  {
                  contentArticle?.contentParagraphs&& contentArticle?.contentParagraphs.length > 0 &&
                      // <span>
                      deleteTag(
                        contentArticle?.contentParagraphs[0].paragraphContent ||
                          ""
                      )
                    // </span>
                  }
                </div>
                <div className={styles.askAuthorName}>
                  <div className={styles.askAuthorNameImg}>
                    <img src={img3} alt="" />
                    <p>{contentArticle?.authors?.[0]?.authorName}</p>
                    <span>{timeStampFun(contentArticle?.createTime)}</span>
                  </div>
                  <div className={styles.askAuthorNameList}>
                    {contentArticle &&
                      contentArticle?.keywordInfos &&
                      contentArticle?.keywordInfos.length > 0 &&
                      contentArticle?.keywordInfos.map((val: any, index: any) => {
                        if (index < 6) {
                          return <p key={index}>#{val.keyword}</p>;
                        }
                      })}
                  </div>
                </div>
                <i className={styles.askLine}></i>
                <div className={styles.problem1}>
                  <img src={ask2} alt="" />
                  <p>医生回答</p>
                </div>
                {/* 医生回答列表 */}
                <div className={styles.askDoctorList}>
                  {dataInfo &&
                    dataInfo.length > 0 &&
                    dataInfo.map((val: any, index: any) => {
                      return (
                        <div
                          className={styles.list}
                          key={index}
                          onClick={() => {
                            val.authors?.map((person: any) => {
                              if (person.authorType == 2) {
                                window.open(
                                  window.location.origin +
                                    "/doctor/" +
                                    person?.doctorInfo?.docId
                                );
                              }
                            });
                          }}
                        >
                          <div className={styles.listTop}>
                            {val.authors?.map((person: any, indexs: number) => {
                              let operationalOpenRxStatus = false;
                              if (person.authorType == 2) {
                                departDatas &&
                                  departDatas.length > 0 &&
                                  departDatas.map((val: any) => {
                                    if (
                                      val.docId == person?.doctorInfo?.docId &&
                                      val.operationalOpenRxStatus == 1
                                    ) {
                                      operationalOpenRxStatus = true;
                                    }
                                  });
                              }
                              return person.authorType == 2 ||
                                person.authorType == 5 ? (
                                <div
                                  className={styles.doctorInfoImg}
                                  key={indexs}
                                >
                                  <img
                                    src={
                                      "https://image.healthjd.com/nethpim/" +
                                      person.headPic
                                    }
                                    alt={
                                      person.doctorInfo?.docName ||
                                      person.authorName
                                    }
                                  />
                                  <div className={styles.doctorInfoImgRight}>
                                    <div className={styles.doctorInfoImgTop}>
                                      {person.doctorInfo?.selfSupport && (
                                        <img src={selfSupport} alt="" />
                                      )}
                                      {operationalOpenRxStatus && (
                                        <img src={Prescribible} alt="" />
                                      )}
                                      <div
                                        className={styles.doctorInfoImgTopName}
                                      >
                                        {person.authorName}
                                      </div>
                                      <span>
                                        {person.docTitleName
                                          ? person.docTitleName
                                          : person.titleName}
                                      </span>
                                    </div>
                                    <div className={styles.doctorInfoImgBotton}>
                                      {person.doctorInfo?.hospitalGrade === 3 && (
                                        <img src={Triple} alt="" />
                                      )}
                                      {person?.doctorInfo ? (
                                        <p
                                          data-a-href={
                                            "/doctor/" +
                                            person?.doctorInfo?.docId
                                          }
                                        >
                                          <span 
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              onClickOpen("/hospital/" + person?.hospitalId);
                                            }}
                                            data-a-href={"/hospital/" + person?.hospitalId}>{person.hospitalName}</span>
                                          {person.docId}
                                          {' '}
                                          <span onClick={(e) => {
                                            e.stopPropagation();
                                            onClickOpen(`/hospital/department/${person?.hospitalId}-${person?.secondDepartId}`)
                                          }}
                                          data-a-href={`/hospital/department/${person?.hospitalId}-${person?.secondDepartId}`}
                                          >{person.secondDepartName}</span>
                                        </p>
                                      ) : (
                                        <p>
                                          {person.hospitalName} {person.docId}
                                          {person.departName}
                                        </p>
                                      )}
                                      <div
                                        className={styles.doctorInfoImgBotton1}
                                      >
                                        {person.hospitalName} {person.departName}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : null;
                            })}
                            {val.authors?.map((person: any, indexs: number) => {
                              if (person.authorType == 2) {
                                return (
                                  <div key={indexs} className={styles.listTopBtn}>
                                    向他咨询
                                  </div>
                                );
                              }
                            })}
                          </div>
                          <div className={styles.listText}>
                            {val.contentParagraphs?.map(
                              (item: any, index: number) => (
                                <div className={styles.fooContent} key={index}>
                                  {item.paragraphContent &&
                                    deleteTag(item.paragraphContent)}
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      );
                    })}
                </div>
                <div className={styles.askwarning}>
                  <img src={jdh} alt="" />
                  <p>
                    本站内容仅供医学知识科普使用，任何关于疾病、用药建议都不能替代执业医师当面诊断，请谨慎参阅。
                  </p>
                </div>
              </div>
            )}
            {/* 相关问答 */}
            {askDatas && askDatas.length > 0 && (
              <div className={styles.askQa}>
                <div className={styles.askQaTit}>相关问答</div>
                {askDatas.map((val: any, index: any) => {
                  return (
                    <div
                      className={styles.askQaList}
                      key={index}
                      onClick={() => {
                        window.open(
                          window.location.origin + "/ask/" + val?.contentId
                        );
                      }}
                    >
                      <div className={styles.askQaListTit}>
                        <div className={styles.askQaListTitLeft}>
                          <img src={ask1} alt="" />
                          <p
                            data-tag-h2
                            data-a-href={ "/ask/" + val?.contentId
                            }
                          >
                            {val.contentName}
                          </p>
                        </div>
                        <div className={styles.articleListTopInfo}>
                          <span data-a-nofollow="true">点击查看</span>
                          <img src={icon_right} alt="" />
                        </div>
                      </div>
                      <div>
                        {val.contentRelations.length > 0 &&
                        val?.contentRelations[0].contentParagraphs.length > 0 ? (
                          <div className={styles.askQaListCent}>
                            {deleteTag(
                              val?.contentRelations[0].contentParagraphs[0]
                                .paragraphContent
                            )}
                          </div>
                        ) : (
                          <div className={styles.askQaListCent}>无</div>
                        )}
                      </div>
                      <div className={styles.askQaListImg}>
                        {val.contentRelations.length > 0 &&
                          val.contentRelations.map((v: any, index: any) => {
                            if (index < 4) {
                              return (
                                <img
                                  key={index}
                                  src={
                                    "https://image.healthjd.com/nethpim/" +
                                    v.authors?.[0]?.headPic
                                  }
                                  alt={v.authors?.[0]?.authorName}
                                />
                              );
                            }
                            return "";
                          })}
                        <p
                          style={{
                            left:
                              (val.contentRelations.length < 5
                                ? 12 * (val.contentRelations.length + 1) + 8
                                : 12 * 6) + "px",
                          }}
                        >
                          共{val.contentRelations.length}个医生回答
                        </p>
                        <span>{timeStampFun(val.createTime)}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            {/* 与医生的问诊记录 */}
            {contentDiagData && contentDiagData?.length > 0 && (
              <div className={styles.consultationList}>
                <div className={styles.consultationListTit}>
                  <div>相关问诊记录</div>
                </div>
                <ul>
                  {contentDiagData &&
                    contentDiagData.map((itme: any, index: any) => {
                      let text;
                      try {
                        text =
                          itme.contentParagraphs &&
                          itme.contentParagraphs.length > 0 &&
                          itme.contentParagraphs[0].paragraphContent &&
                          JSON.parse(itme.contentParagraphs[0].paragraphContent);
                      } catch (error) {
                        console.log(error, "errorerrorerrorerrorerror");
                      }

                      let textContent =
                        text &&
                        text.length &&
                        text
                          .map((val: any) => {
                            if (
                              val?.body?.type == "text" &&
                              val?.from?.app == "jd.doctor" &&
                              val?.body?.content
                            ) {
                              return val?.body?.content;
                            }
                          })
                          .filter((itme: any) => {
                            return itme && itme.trim();
                          })
                          .join("")
                          .substring(0, 100);
                      return (
                        <li
                          key={index}
                          onClick={() => {
                            setTimeout(() => {
                              let diagid = itme?.contentDiags[0]?.diagId;
                              window.open(
                                window.location.origin + "/qa/" + diagid
                              );
                            }, 200);
                          }}
                          data-a-nofollow="true"
                        >
                          <div className={styles.consultationListTop}>
                            <div
                              className={styles.consultationListTopText}
                              data-tag-h2
                              data-a-href={
                                "/qa/" +
                                itme?.contentDiags[0]?.diagId
                              }
                            >
                              {itme?.contentName}
                            </div>
                            <div className={styles.consultationListTopText1}>
                              {itme?.contentName + ":" + textContent}
                            </div>
                            <div className={styles.consultationListTopInfo}>
                              <span data-a-nofollow="true">点击查看</span>
                              <img src={icon_right} alt="" />
                            </div>
                          </div>
                          <div className={styles.consultationListBon}>
                            <div className={styles.consultationListBonLeft}>
                              <div
                                className={styles.consultationListBonLeftText1}
                              >
                                <h3>总交流次数</h3>
                                <h5>
                                  {(itme?.contentDiags &&
                                    itme?.contentDiags[0]?.doctorExchangeCount +
                                      itme?.contentDiags[0]
                                        ?.patientExchangeCount) ||
                                    0}
                                </h5>
                              </div>
                              <div
                                className={styles.consultationListBonLeftLine}
                              />
                              <div
                                className={styles.consultationListBonLeftText2}
                              >
                                <h3>医生回复次数</h3>
                                <h5>
                                  {(itme?.contentDiags &&
                                    itme?.contentDiags[0]?.doctorExchangeCount) ||
                                    0}
                                </h5>
                              </div>
                            </div>
                            <div className={styles.consultationListBonInfo}>
                              <span>患者：</span>
                              <h4>
                                {itme?.contentDiags &&
                                itme?.contentDiags[0]?.patientSex == 1
                                  ? "男 "
                                  : "女 "}
                                {(itme?.contentDiags &&
                                  itme?.contentDiags[0]?.patientAge) ||
                                  0}
                              </h4>
                            </div>
                          </div>
                        </li>
                      );
                    })}
                </ul>
              </div>
            )}

            {/* 医生的其他文章 */}
            {contentOtherArt && contentOtherArt?.length > 0 && (
              <div className={styles.articleList}>
                <div className={styles.articleListTit}>
                  <div>其他文章</div>
                </div>
                <ul>
                  {contentOtherArt.map((itme: any, index: any) => {
                    return (
                      <li
                        key={index}
                        onClick={() => {
                          window.open(
                            window.location.origin +
                              "/pccontent/" +
                              itme?.contentId
                          );
                        }}
                      >
                        <div className={styles.articleImg}>
                          {itme.titlePicUrl && (
                            <img
                              src={
                                "https://image.healthjd.com/nethpim/" +
                                itme.titlePicUrl
                              }
                              alt=""
                              className={styles.articleImg1}
                            />
                          )}
                          <div className={styles.articleWidth}>
                            <div className={styles.articleListTop}>
                              <div
                                className={styles.articleListTopText}
                                data-tag-h2
                                data-a-href={
                                  "/pccontent/" +
                                  itme?.contentId
                                }
                              >
                                {itme?.contentName}
                              </div>
                              <div className={styles.articleListTopInfo}>
                                <span data-a-nofollow="true">点击查看</span>
                                <img src={icon_right} alt="" />
                              </div>
                            </div>
                            <div className={styles.consultationListBon}>
                              <div className={styles.consultationListBonLeft}>
                                <div
                                  className={styles.consultationListBonLeftText1}
                                >
                                  {itme?.contentParagraphs &&
                                    itme?.contentParagraphs.length > 0 &&
                                    itme?.contentParagraphs[0]
                                      ?.paragraphContent && (
                                      <h3
                                        dangerouslySetInnerHTML={{
                                          __html: deleteTag(
                                            itme?.contentParagraphs[0]
                                              .paragraphContent
                                          ),
                                        }}
                                      ></h3>
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
          </div>
          {/* 右 */}
          <div className={styles.right}>
            <div className={styles.rightFloat}>
              {departDatas &&
                departDatas.length > 0 &&
                departDatas.map((itme: any, index: any) => {
                  return (
                    <div
                      key={index}
                      className={styles.doctorInfo}
                      onClick={() => {
                        if (itme.docId) {
                          let url = `/doctor/${itme.docId}`;
                          if (departData?.doctorSource === 1) {
                            url = `/yellowdoctor/${itme.docId}`;
                          }
                          setTimeout(() => {
                            onClickOpen(
                              window.location.origin + url
                            );
                          }, 200);
                        }
                      }}
                    >
                      <div className={styles.doctorInfoTit}>接诊医生</div>
                      <div className={styles.doctorInfoImg}>
                        <img
                          src={
                            "https://image.healthjd.com/nethpim/" +
                            itme?.doctorHeadImg
                          }
                          alt={itme?.docName}
                        />
                        <div className={styles.doctorInfoImgRight}>
                          <div className={styles.doctorInfoImgTop}>
                            {itme?.selfSupport && <img src={selfSupport} alt="" />}
                            {itme?.operationalOpenRxStatus && (
                              <img src={Prescribible} alt="" />
                            )}
                            <div className={styles.doctorInfoImgTopName1}>
                              {itme?.docName +
                                ":" +
                                window.location.origin +
                                `${departData?.doctorSource === 1 ? `/yellowdoctor/${itme.docId}` : `/doctor/${itme.docId}`}`}
                            </div>
                            <div
                              className={styles.doctorInfoImgTopName}
                              data-a-href={`${departData?.doctorSource === 1 ? `/yellowdoctor/${itme.docId}` : `/doctor/${itme.docId}`}`}
                            >
                              {itme?.docName}
                            </div>
                            <span>{itme?.titleName}</span>
                          </div>
                          <div className={styles.doctorInfoImgBotton}>
                            {itme?.hospitalGrade === 3 && (
                              <img src={Triple} alt="" />
                            )}
                            <p>
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  onClickOpen("/hospital/" + itme?.hospitalId);
                                }}
                                data-a-href={"/hospital/" + itme?.hospitalId}
                              >{itme?.hospitalName}</span>
                              {' '}
                              <span onClick={(e) => {
                                e.stopPropagation();
                                onClickOpen(`/hospital/department/${itme?.hospitalId}-${itme?.secondDepartId}`)
                              }}
                              data-a-href={`/hospital/department/${itme?.hospitalId}-${itme?.secondDepartId}`}
                              >{itme?.secondDepartName}</span>
                            </p>
                            <div className={styles.doctorInfoImgBotton1}>
                              <span>{itme?.hospitalName}</span>{' '}<span>{itme?.secondDepartName}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={styles.doctorInfoText1}>
                        擅长: {itme?.docGoodAt}
                      </div>
                      <div className={styles.doctorInfoText}>
                        擅长: {itme?.docGoodAt || "无"}
                      </div>
                      <div className={styles.doctorInfoNum}>
                        <div className={styles.doctorInfoNum1}>
                          <h2>好评率</h2>
                          <h5>
                            {Math.floor(itme?.patientEvaluationRate * 100) || 0}%
                          </h5>
                        </div>
                        <div className={styles.doctorInfoLine}></div>
                        <div className={styles.doctorInfoNum2}>
                          <h2>在线问诊量</h2>
                          <h5>{itme?.receivePatientNum || 0}</h5>
                        </div>
                      </div>
                      <div className={styles.doctorInfoBut}>立即咨询</div>
                    </div>
                  );
                })}
              <div className={styles.overbookingCode}>
                {QRCodeFun()}
                <div>
                  <h3>扫一扫 立即下单</h3>
                  {/* <h6>仅支持手机扫码购买</h6> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      <div className={styles.footerData} id="m_common_bottom"></div>
      {/* 底部 */}
      {dataInfo && dataInfo.length == 1
        ? departData && (
            <div className={styles.bottom}>
              <div className={styles.bottomDoctorInfo}>
                {departData && (
                  <>
                    <img
                      src={
                        "https://image.healthjd.com/nethpim/" +
                        departData?.doctorHeadImg
                      }
                      alt={departData?.docName}
                    />
                    <div className={styles.doctorInfoImgRight}>
                      <div className={styles.doctorInfoImgTop}>
                        <div className={styles.doctorInfoImgTopName}>
                          {departData?.docName}
                        </div>
                        <span>{departData?.titleName}</span>
                        {/* <span>{departData?.departName}</span> */}
                        <p>已认证</p>
                      </div>
                      <div className={styles.doctorInfoImgBotton}>
                        {departData?.hospitalGrade === 3 && (
                          <img src={TripleHospital} alt="" />
                        )}
                        <p>
                          {departData?.hospitalName}{" "}
                          {departData?.secondDepartName}
                        </p>
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className={styles.bottomBtn}>
                <button
                  className={styles.bottomBtn1}
                  onClick={() => {
                    setTimeout(() => {
                      onClickOpen(
                        window.location.origin + "/doctor/" + departData.docId
                      );
                    }, 200);
                  }}
                >
                  立即咨询
                </button>
                <Popover content={content}>
                  <button className={styles.bottomBtn2}>
                    扫码关注医生，方便随时咨询
                  </button>
                </Popover>
              </div>
            </div>
          )
        : dataInfo &&
          dataInfo.length > 1 && (
            <div className={styles.bottom1}>
              <div className={styles.bottomDoctorInfo}>
                {dataInfo &&
                  dataInfo.length > 0 &&
                  dataInfo.map((val: any, index: any) => {
                    if (index < 4) {
                      return (
                        <img
                          key={index}
                          src={
                            "https://image.healthjd.com/nethpim/" +
                            val?.authors?.[0]?.headPic
                          }
                          alt={val?.authors?.[0]?.authorName}
                        />
                      );
                    }
                  })}
                {dataInfo && dataInfo.length > 1 && (
                  <p
                    style={{
                      left:
                        (dataInfo && dataInfo.length < 5
                          ? 18 * (dataInfo && dataInfo.length + 1) + 8
                          : 18 * 6) + "px",
                    }}
                  >
                    共{dataInfo && dataInfo.length}个医生回答
                  </p>
                )}
              </div>
              <div className={styles.bottomBtn}>
                <Popover content={content}>
                  <button className={styles.bottomBtn1}>立即咨询</button>
                </Popover>
              </div>
            </div>
          )}
    </div>
  );
};

export default Pccontent;
